"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
function BrandedText(props) {
    return (react_1.default.createElement("span", { className: (0, classMap_1.default)("mpng-ux-branded-text", props.className) },
        react_1.default.createElement("span", { className: (0, classMap_1.default)("branded-text-primary", props.primary ? "text-".concat(props.primary) : "") }, "Ed"),
        react_1.default.createElement("span", { className: (0, classMap_1.default)("branded-text-secondary", props.secondary ? "text-".concat(props.secondary) : "") },
            "genuity",
            props.registered && react_1.default.createElement("span", { className: "branded-text-registered text-xxs text-super" }, "\u00AE"))));
}
exports.default = BrandedText;
